module.exports = __webpack_public_path__ + "public/img/house.b7f2189f.png";